export enum BasicResourceType {
  CampaignBrief = "CampaignBrief",
  CampaignBriefProducts = "CampaignBriefProducts",
  ExecutionBrief = "ExecutionBrief",
  Flyer = "Flyer",
  FlyerPage = "Page",
  FlyerPagePosition = "pageposition",
  FlyerPagePositionProduct = "pagepositionproduct",
  WorkOrder = "WorkOrder",
  WorkOrderProducts = "WorkOrderProducts",
}
